"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../constants");
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var LiteFooter = function LiteFooter(_ref) {
  var socialLinks = _ref.socialLinks;
  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: "d8-u-component-padding d8-u-super-dark-blue-bg d8-u-text-center d8-u-color-white"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm text-center d8-u-text-semi-bold"
  }, "Follow Us On Social Media"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-center margin-y-lg"
  }, socialLinks.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      key: JSON.stringify(item),
      href: item.link,
      external: true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-center margin-x-md d8-u-icon-size d8-u-white-bg radius-50% padding-xs"
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: "icon--sm",
      name: item.icon,
      fill: _constants.COLORS.PRIMARY_DARKER
    })));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "d8-u-color-white margin-right-md",
    href: "https://policies.google.com/privacy"
  }, "Privacy Policy"), /*#__PURE__*/_react["default"].createElement("span", {
    className: ""
  }, "|"), /*#__PURE__*/_react["default"].createElement("a", {
    className: "d8-u-color-white margin-left-md",
    href: "https://policies.google.com/terms"
  }, "Terms & Conditions")));
};
LiteFooter.propTypes = {
  socialLinks: _propTypes["default"].array
};
LiteFooter.defaultProps = {
  socialLinks: [{
    link: 'https://www.facebook.com/theyachtweek',
    icon: 'facebook'
  }, {
    link: 'https://instagram.com/theyachtweek/',
    icon: 'instagram'
  }, {
    link: 'https://vm.tiktok.com/ZMRJfhnj5/',
    icon: 'tiktok'
  }, {
    link: 'https://www.youtube.com/user/TheYachtWeek',
    icon: 'youtube-brand'
  }]
};
var _default = exports["default"] = LiteFooter;